<template>
  <div class="full-screen-div flex flex-col justify-start items-center">
    <div
      class="dashboard_navbar max-w-7xl w-full items-center flex flex-row justify-between lg:px-12 md:px-4 px-3 py-4">
      <div class="flex justify-start gap-4 w-2/5">
        <img src="@/assets/images/logot.svg" class="w-24 h-24 cursor-pointer mr-10" @click="redirectHome" />
        <div class="text-white flex flex-col justify-center h-24">
          <p class="welcome_msg text-2xl font-bold">
            //Welcome
            <span v-if="activeUserInfo.firstName" class="text-primary">{{ cropMiddleToLength(activeUserInfo.firstName,
              12) }}!</span>
            <span v-else class="text-primary">to Decast!</span>
          </p>
          <p class="text-lg" style="color: #22c55e; flex-wrap: nowrap;">
            /* what are we starting today? */
          </p>
        </div>
      </div>

      <div class="w-3/5 flex flex-row gap-6 justify-end h-24 items-center">
        <!-- <div v-if="accessToken && activeUserInfo.provider == 'wallet'" class="flex gap-6">
          <img src="@/assets/images/pixel_wallet.svg" class="w-8 h-6 cursor-pointer" />
          <p class="text-lg">{{ cropMiddleToLength(activeUserInfo.firstName, 12) }}!</p>
        </div>
        <div v-else-if="accessToken && activeUserInfo.provider == 'email'" class="flex gap-2">
          <img src="@/assets/images/pixel_email.svg" class="w-8 h-6 cursor-pointer" />
          <p class="text-lg">{{ activeUserInfo.email }}</p>
        </div> -->
        <!-- <img src="@/assets/images/pixel_smile.svg" class="w-12 h-12 cursor-pointer" /> -->
        <div class="">
          <div v-if="accessToken || loggedIn">
            <SimpleMenu :menuList="profileMenuItems">
              <template #menuButton>
                <div class="pfp">
                  <!-- <vs-avatar :text="getFirstLetter" color="primary" class="m-0 shadow-md"
                    :src="activeUserInfo.profile_pic ? activeUserInfo.profile_pic : ''" size="40px" /> -->
                  <vs-avatar :text="getFirstLetter" color="primary" class="m-0 shadow-md"
                    :src="activeUserInfo.profile_pic || require('@/assets/images/user-icon-placeholder.png')"
                    size="40px" />
                </div>
              </template>
            </SimpleMenu>
          </div>
          <button v-else class="butt cursor-pointer" @click="open">
            Login
          </button>
        </div>
      </div>
    </div>

    <div class="dashboard_content max-w-7xl w-full flex flex-row gap-3 justify-start lg:px-12 md:px-4 px-3 py-4">
      <div class="flex flex-col justify-start gap-4 mr-10">

        <vx-tooltip text="/ Rooms" position="right">
          <div class="w-24 h-24 cursor-pointer flex flex-col items-center justify-center gap-2" @click="onRoom"
            :class="{ 'calls_btn_': true, 'calls_clicked': isClicked1 }">
            <img :src="callSrc" alt="Image">
            <p class="font-semibold text-base">CALLS</p>
          </div>
        </vx-tooltip>


        <vx-tooltip text="/ Casts" position="right">
          <div class="w-24 h-24 cursor-pointer flex flex-col items-center justify-center gap-2" @click="onCasts"
            :class="{ 'casts_btn': true, 'cast_clicked': isClicked2 }">
            <img :src="castSrc" alt="Image">
            <p class="font-semibold text-base">CASTS</p>
          </div>
        </vx-tooltip>


        <vx-tooltip text="/ Decast" position="right">
          <div class="w-24 h-24 cursor-pointer flex flex-col items-center justify-center gap-2" @click="onDecasts"
            :class="{ 'decast_btn': true, 'decast_clicked': isClicked3 }">
            <img :src="decastSrc" alt="Image">
            <p class="font-semibold text-base">DECAST</p>
          </div>
        </vx-tooltip>

        <!-- <vx-tooltip text="/ Contact" position="right">
          <div class="w-24 h-24 cursor-pointer flex flex-col items-center justify-center gap-2" @click="onContact"
            :class="{ 'contact_btn': true, 'contact_clicked': isClicked5 }">
            <img class="object-fit w-12 h-12" :src="contactSrc" alt="Image">
            <p class="font-semibold text-base">CONTACTS</p>
          </div>
        </vx-tooltip> -->

        <vx-tooltip text="/ Storages" position="right">
          <div class="w-24 h-24 cursor-pointer flex flex-col items-center justify-center gap-2" @click="onStorages"
            :class="{ 'storage_btn': true, 'storage_clicked': isClicked4 }">
            <img class="object-fit w-12 h-12" :src="storageSrc" alt="Image">
            <p class="font-semibold text-base">STORAGES</p>
          </div>
        </vx-tooltip>

      </div>

      <div class="w-full flex flex-col justify-start gap-2">


        <div>
          <router-view />
        </div>

      </div>
    </div>
    <ResetPasswordModal v-if="activeModal === 'resetPassModal'" :toggleActiveModal="toggleActiveModal" />
    <ProfileModal v-if="activeModal === 'profileModal'" :toggleActiveModal="toggleActiveModal" />
  </div>
</template>

<script>
import RoomSection from './rooms/RoomSection.vue';
import CastSection from './casts/CastSection.vue';
import DecastSection from './decast/DecastSection.vue';
import constants from '../../../constant';
import { utils } from '@/mixins/index';
import SimpleMenu from '@/components/common/simpleMenu/SimpleMenu.vue';
import ResetPasswordModal from '@/views/dashboard/components/ResetPasswordModal';
import ProfileModal from '@/views/dashboard/components/ProfileModal';
import callIcon from '@/assets/images/call-icon.svg';
import callIconAlt from '@/assets/images/call-icon-alt.svg';
import castIcon from '@/assets/images/cast-icon.svg';
import castIconAlt from '@/assets/images/cast-icon-alt.svg';
import decastIcon from '@/assets/images/decast-icon.svg';
import decastIconAlt from '@/assets/images/decast-icon-alt.svg';
import storageIcon from '@/assets/images/storage_black.png';
import storageIconAlt from '@/assets/images/storage_white.png';
import contactIcon from '@/assets/images/contact.svg';
import contactIconAlt from '@/assets/images/contact-alt.svg';

export default {
  name: 'Dashboard',
  components: {
    RoomSection,
    CastSection,
    DecastSection,
    SimpleMenu,
    ResetPasswordModal,
    ProfileModal,
  },
  data() {
    return {
      focusYourRooms: true,
      showRoomSection: true,
      showCastSection: false,
      showCommunitySection: false,
      rooms: true,
      casts: false,
      decasts: false,
      storages: false,
      isClicked1: true,
      isClicked2: false,
      isClicked3: false,
      isClicked4: false,
      isClicked5: false,
      activeModal: '',
      offset: 0,
      url: constants.challengeUri,
      iframe: false,
      userMenuVisible: false,
      callSrc: callIcon,
      castSrc: castIcon,
      decastSrc: decastIcon,
      storageSrc: storageIconAlt,
      contactSrc: contactIconAlt,
      profileMenuItems: [
        {
          label: "My Profile",
          icon: () => import("@/assets/svgs/menu-icons/usermenu.vue"),
          onClick: () => this.$router.push('/profile')
        },
        {
          label: "2FA",
          icon: () => import("@/assets/svgs/menu-icons/setting.vue"),
          onClick: () => this.configure2fa()
        },
        {
          label: "Reset Password",
          icon: () => import("@/assets/svgs/menu-icons/setting.vue"),
          onClick: () => this.toggleActiveModal('resetPassModal')
        },
        {
          label: "Wallet",
          icon: () => import("@/assets/svgs/menu-icons/wallet.vue"),
          onClick: () => this.$router.push('/addfunds')
        },
        // {
        //   label: "Help Center",
        //   icon: () => import("@/assets/svgs/menu-icons/help.vue"),
        // },
        {
          label: "Logout",
          icon: () => import("@/assets/svgs/menu-icons/export.vue"),
          onClick: () => {
            this.$cookies.remove('userId');
            this.$cookies.remove('Token');
            this.$router.push('/');
            return this.$store.dispatch('auth/v2logOut');
          }
        }
      ]
    };
  },
  computed: {
    activeUserInfo() {
      return this.$store.state.AppActiveUser;
    },
    accessToken() {
      return this.$store.state.auth.accessToken;
    },
    loggedIn() {
      return this.$store.state.auth.loggedIn;
    },
    getFirstname() {
      return this.activeUserInfo.firstName;
    },
    getFirstLetter() {
      return this.activeUserInfo?.firstName?.[0] || 'D';
    },
  },
  created() {
    if (this.$router.currentRoute.path === '/dashboard/decast') {
      this.clicked = true;
      this.isClicked2 = false;
      this.isClicked1 = false;
      this.isClicked3 = true;
      this.isClicked4 = false;
      this.isClicked5 = false;
    } else if (this.$router.currentRoute.path === '/dashboard/casts') {
      this.isClicked2 = true;
      this.isClicked1 = false;
      this.isClicked3 = false;
      this.isClicked4 = false;
      this.isClicked5 = false;
    } else if (this.$router.currentRoute.path === '/dashboard/rooms') {
      this.isClicked2 = false;
      this.isClicked1 = true;
      this.isClicked3 = false;
      this.isClicked4 = false;
      this.isClicked5 = false;
    } else if (this.$router.currentRoute.path === '/dashboard/contact') {
      this.isClicked2 = false;
      this.isClicked1 = false;
      this.isClicked3 = false;
      this.isClicked4 = false;
      this.isClicked5 = true;
    }
    else if (this.$router.currentRoute.path === '/dashboard/storage') {
      this.isClicked2 = false;
      this.isClicked1 = false;
      this.isClicked3 = false;
      this.isClicked4 = true;
      this.isClicked5 = false;

      this.storageSrc = storageIcon;
      this.callSrc = callIconAlt;
      this.castSrc = castIconAlt;
      this.decastSrc = decastIconAlt;
      this.contactSrc = contactIconAlt;
    }


  },
  mounted() {
    const gb_redirect = localStorage.getItem("LOG_REDIRECT")
    if (gb_redirect) {
      localStorage.removeItem("LOG_REDIRECT");
      const url = new URL(gb_redirect);
      const path = url.pathname + url.search + url.hash; // Extract path, query, and hash
      this.$router.push(path);
    }
    this.verifyAuthToken();
    // this.userInfo = { ...this.$store.state.AppActiveUser };
    // this.$store.commit('UPDATE_USER_INFO', this.userInfo);
    setTimeout(function () {
      const ifram = document.getElementById('extFrame');
      const wind = ifram.contentWindow;
      const message = {
        accessToken: localStorage.getItem("accessToken"),
        refreshToken: localStorage.getItem("refreshToken")
      };
      wind.postMessage(JSON.stringify(message), this.$globals.roomDomain);
    }, 2000);
    // this.onRoom();
  },
  methods: {
    configure2fa() {
      this.$router.push({ name: 'Configure 2fa' });
    },
    verifyAuthToken() {
      this.$store.dispatch('auth/v2verifyAuthToken');
    },
    toggleActiveModal(setModal) {
      this.activeModal = setModal;
    },
    scroll(offset) {
      this.offset = offset;
    },
    closeIframe() {
      var iframe = document.getElementById('myIframe');
      iframe.style.display = 'none';
    },
    open() {
      console.log('open');
      this.iframe = !this.iframe;
      this.url = constants.challengeUri;
      // this.url = 'http://localhost:8080/login';
      document.getElementsByTagName('iframe')[0].style.height = '66.7%';
      document.getElementsByTagName('iframe')[0].style.width = '32%';
      console.log(this.iframe);
      // window.location.href = constants.challengeUri;
    },
    toggleUserMenu() {
      console.log('Clicked');
      this.userMenuVisible = !this.userMenuVisible;
    },
    redirectHome() {
      this.$router.push('/');
    },

    changeFocus(toYourRooms) {
      this.focusYourRooms = toYourRooms;
    },
    onRoom() {
      this.$router.push('/dashboard/rooms');
      this.isClicked2 = false;
      this.isClicked1 = true;
      this.isClicked3 = false;
      this.isClicked4 = false;
      this.isClicked5 = false;

      this.storageSrc = storageIconAlt;
      this.callSrc = callIcon;
      this.castSrc = castIconAlt;
      this.decastSrc = decastIconAlt;
      this.contactSrc = contactIconAlt;
    },

    onCasts() {
      this.$router.push('/dashboard/casts');
      this.isClicked2 = true;
      this.isClicked1 = false;
      this.isClicked3 = false;
      this.isClicked4 = false;
      this.isClicked5 = false;

      this.storageSrc = storageIconAlt;
      this.callSrc = callIconAlt;
      this.castSrc = castIcon;
      this.decastSrc = decastIconAlt;
      this.contactSrc = contactIconAlt;
    },

    onDecasts() {
      this.$router.push('/dashboard/decast');
      this.isClicked2 = false;
      this.isClicked1 = false;
      this.isClicked3 = true;
      this.isClicked4 = false;
      this.isClicked5 = false;

      this.storageSrc = storageIconAlt;
      this.callSrc = callIconAlt;
      this.castSrc = castIconAlt;
      this.decastSrc = decastIcon;
      this.contactSrc = contactIconAlt;
    },
    onContact() {
      this.$router.push('/dashboard/contact');
      this.isClicked2 = false;
      this.isClicked1 = false;
      this.isClicked3 = false;
      this.isClicked4 = false;
      this.isClicked5 = true;

      this.storageSrc = storageIconAlt;
      this.callSrc = callIconAlt;
      this.castSrc = castIconAlt;
      this.decastSrc = decastIconAlt;
      this.contactSrc = contactIcon;
    },

    onStorages() {
      this.$router.push('/dashboard/storage');
      this.isClicked2 = false;
      this.isClicked1 = false;
      this.isClicked3 = false;
      this.isClicked4 = true;
      this.isClicked5 = false;

      this.storageSrc = storageIcon;
      this.callSrc = callIconAlt;
      this.castSrc = castIconAlt;
      this.decastSrc = decastIconAlt;
      this.contactSrc = contactIconAlt;
    },

    cropMiddleToLength(id, maxLength = 12, mask = '***') {
      const chars = Array.from(String(id || ''));
      if (chars.length <= maxLength) return chars.join('');
      const keep = maxLength - mask.length;
      const start = Math.ceil(keep / 2);
      const end = Math.floor(keep / 2);
      return chars.slice(0, start).join('') + mask + chars.slice(-end).join('');
    }
  },
};
</script>

<style scoped>
* {
  font-family: 'JetBrains Mono', monospace !important;
}

.full-screen-div {
  width: 100%;
  height: 100%;
  background: #0a0b0f;
  color: white;
}

.dashboard_navbar {
  height: 16vh;
}

.dashboard_content {
  height: 84vh;
}

.basic_details_cont {
  /* border: 1px solid white;
  height: 70vh; */
}

.options-button {
  background: none;
  color: #fff;
  font-size: 16px;
  font-weight: 700;
  cursor: pointer;
}

.focused-button {
  color: #d7df23;
}

.con-vs-tooltip {
  border-radius: 0px !important;
  /* border: 1px solid red; */
  color: #0a0b0f !important;
}

.calls_btn_ {
  background-color: black;
  border: 1px solid white;
  color: white;
}

.calls_clicked {
  background-color: white;
  color: black;
}

.casts_btn {
  background-color: black;
  border: 1px solid white;
  color: white;
}

.cast_clicked {
  background-color: white;
  color: black;
}

.decast_btn {
  background-color: black;
  border: 1px solid white;
  color: white;
}

.decast_clicked {
  background-color: white;
  color: black;
}

.storage_btn {
  background-color: black;
  border: 1px solid white;
  color: white;
}

.storage_clicked {
  background-color: white;
  color: black;
}

.contact_btn {
  background-color: black;
  border: 1px solid white;
  color: white;
}

.contact_clicked {
  background-color: white;
  color: black;
}
</style>